import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourSequence } from '../entities/project-tour-ontour-sequence.entity';

type Result = TourSequence[];

export const getTourSequences = createAppAsyncThunk(
  'projectTourOntour/getTourSequences',
  async (
    _,
    { extra: { projectTourOntourGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      const tourId = selectCurrentProjectTour(getState())?.id || -1;
      const sequences = await projectTourOntourGateway.getSequences(tourId);
      return sequences;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetTourSequences.Message.error'));
}
